import React from 'react';
import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { JSErrorPageAsync } from '@atlassian/jira-error-pages/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import type OnboardingGetStartedPageType from '@atlassian/jira-spa-apps-onboarding-get-started/src/index.tsx';
import type SoftwareOnboardingPageType from '@atlassian/jira-spa-apps-software-onboarding/src/index.server.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazySoftwareOnboardingPageOld = lazyForPaint<typeof SoftwareOnboardingPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-software-onboarding", jiraSpaEntry: "async-software-onboarding" */ '@atlassian/jira-spa-apps-software-onboarding'
		),
	),
);

const loadSoftwareOnboardingPage = () =>
	markAsProductBundleReady(
		// eslint-disable-next-line jira/import/webpack-magic-comment-entries
		import(
			/* webpackChunkName: "async-software-onboarding", jiraSpaEntry: "async-software-onboarding" */ '@atlassian/jira-spa-apps-software-onboarding'
		).catch((error) => {
			// silently fail to avoid SLO noise https://hello.atlassian.net/wiki/spaces/~rcarvalho/pages/4180233032/Failed+to+fetch+dynamically+imported+module#Error-Type-Checking
			// https://atlassian.slack.com/archives/C0180P6BPLH/p1730864896509449?thread_ts=1730856546.144899&cid=C0180P6BPLH
			log.safeErrorWithoutCustomerData(
				'router-routes.onboarding.entries.loadSoftwareOnboardingPage',
				'Error when loading component',
				error,
			);

			return () => <JSErrorPageAsync />;
		}),
	);

export const LazySoftwareOnboardingPageNew = lazyForPaint<typeof SoftwareOnboardingPageType>(() =>
	loadSoftwareOnboardingPage(),
);

export const LazyOnboardingGetStartedPage = lazyForPaint<typeof OnboardingGetStartedPageType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-onboarding-get-started", jiraSpaEntry: "async-onboarding-get-started" */ '@atlassian/jira-spa-apps-onboarding-get-started'
		),
	),
);

export const SoftwareOnboardingPage = () => (
	<LazyPage
		Page={
			fg('jira-stop-sending-screen-failures-for-load-errors')
				? LazySoftwareOnboardingPageNew
				: LazySoftwareOnboardingPageOld
		}
		pageId="software-onboarding"
		shouldShowSpinner={false}
	/>
);

export const OnboardingGetStartedPage = () => (
	<LazyPage
		Page={LazyOnboardingGetStartedPage}
		pageId="onboarding-get-started"
		shouldShowSpinner={false}
	/>
);
